import React from 'react';
import { Navigate } from 'react-router-dom';

const ProcessoInbox = () => <Navigate to="/process/routing" replace />;

export default ProcessoInbox;
